import type { ExcelAction } from "./types";
import { scanFormulaRegions } from "../../formulas/scanner";
import { openFormulasReport } from "../dialog-host";

export const findUniqueFormulas: ExcelAction = {
  id: "find-unique-formulas",
  label: "List unique formulas",
  description:
    "Scan every worksheet for cells with formulas, group by R1C1 form, show one row per contiguous region in a dialog.",
  async run({ log }) {
    log("scanning formulas in all worksheets...");
    let regions;
    try {
      regions = await scanFormulaRegions();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`scan failed: ${message}`, "error");
      return;
    }

    const uniqueFormulas = new Set(regions.map((r) => r.formula)).size;
    log(
      `${uniqueFormulas} unique formula(s) in ${regions.length} region(s)`,
      regions.length > 0 ? "success" : "info"
    );

    try {
      await openFormulasReport(regions);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`dialog failed: ${message}`, "error");
    }
  },
};
